// src/data/comedians/amy-schumer.js

const base = {
  id: 'amy-schumer',
  slug: 'amy-schumer',
  name: 'Amy Schumer',
  birthYear: 1981,
  image: require('@/assets/images/img_Amy_Schumer.jpg'),
  famousWorks: [
    'Inside Amy Schumer (2013-2016)',
    'Trainwreck (2015)',
    'The Leather Special (2017)',
    'Growing (2019)',
    'I Feel Pretty (2018)',
    'Life & Beth (2022)',
  ],
};

export default [
  {
    ...base,
    lang: 'en',
    nationality: 'American',
    shortBio: 'Fearless feminist comedy voice',
    bio: `Amy Schumer is an American stand-up comedian, actress, and writer known for her feminist comedy and willingness to discuss topics like sex, relationships, and body image with unprecedented frankness. She became a major force in comedy through her Comedy Central series "Inside Amy Schumer" and mainstream film success.\n\nBorn in New York City, Schumer studied theater before pursuing stand-up comedy. Her breakthrough came with her fourth-place finish on "Last Comic Standing" in 2007, but she truly exploded into the mainstream with her Comedy Central show, which won a Peabody Award for its sharp social commentary.\n\nSchumer's film "Trainwreck," which she wrote and starred in, was both a critical and commercial success, establishing her as a leading voice in comedy. She has used her platform to advocate for gun control, women's rights, and body positivity. Her comedy challenges societal expectations while maintaining broad appeal through her relatable, self-deprecating style.`,
    style: 'Feminist, sex-positive, self-deprecating, social commentary',
    achievements: [
      'Emmy Award',
      'Peabody Award',
      'Time 100 most influential people',
      'New York Times bestselling author',
      'Grammy nomination',
      'Writers Guild Award',
    ],
  },
  {
    ...base,
    lang: 'fr',
    nationality: 'Américaine',
    shortBio: 'Voix féministe de la comédie sans peur',
    bio: `Amy Schumer est une comédienne de stand-up, actrice et écrivaine américaine connue pour sa comédie féministe et sa volonté de discuter de sujets comme le sexe, les relations et l'image corporelle avec une franchise sans précédent. Elle est devenue une force majeure de la comédie grâce à sa série Comedy Central "Inside Amy Schumer".\n\nNée à New York, Schumer a étudié le théâtre avant de se tourner vers le stand-up. Sa percée est venue avec sa quatrième place dans "Last Comic Standing" en 2007, mais elle a vraiment explosé dans le grand public avec son émission Comedy Central, qui a remporté un Peabody Award.\n\nSon film "Trainwreck", qu'elle a écrit et dans lequel elle a joué, a été un succès critique et commercial. Elle a utilisé sa plateforme pour militer pour le contrôle des armes à feu, les droits des femmes et la positivité corporelle.`,
    style: 'Féministe, positive sur la sexualité, autodérision, commentaire social',
    achievements: [
      'Emmy Award',
      'Peabody Award',
      'Time 100 personnalités les plus influentes',
      'Auteure de best-sellers du New York Times',
      'Nomination aux Grammy',
      'Writers Guild Award',
    ],
  },
  {
    ...base,
    lang: 'es',
    nationality: 'Americana',
    shortBio: 'Voz feminista de la comedia sin miedo',
    bio: `Amy Schumer es una comediante de stand-up, actriz y escritora estadounidense conocida por su comedia feminista y su disposición a discutir temas como el sexo, las relaciones y la imagen corporal con una franqueza sin precedentes. Se convirtió en una fuerza importante en la comedia a través de su serie de Comedy Central "Inside Amy Schumer".\n\nNacida en Nueva York, Schumer estudió teatro antes de dedicarse al stand-up. Su gran oportunidad llegó con el cuarto lugar en "Last Comic Standing" en 2007, pero realmente irrumpió en el mainstream con su programa de Comedy Central, que ganó un Peabody Award.\n\nSu película "Trainwreck", que escribió y protagonizó, fue un éxito tanto de crítica como comercial. Ha utilizado su plataforma para abogar por el control de armas, los derechos de la mujer y la positividad corporal.`,
    style: 'Feminista, positiva respecto al sexo, autodespreciativa, comentario social',
    achievements: [
      'Emmy Award',
      'Peabody Award',
      'Time 100 personas más influyentes',
      'Autora de bestsellers del New York Times',
      'Nominación al Grammy',
      'Writers Guild Award',
    ],
  },
  {
    ...base,
    lang: 'ar',
    nationality: 'أمريكية',
    shortBio: 'الصوت النسوي الجريء في الكوميديا',
    bio: `إيمي شومر كوميدية ستاند أب وممثلة وكاتبة أمريكية اشتُهرت بكوميديا نسوية واستعدادها لمناقشة موضوعات كالجنس والعلاقات والصورة الجسدية بصراحة غير مسبوقة. أصبحت قوة كبرى في الكوميديا عبر مسلسلها على Comedy Central "Inside Amy Schumer".\n\nوُلدت في نيويورك ودرست المسرح قبل التوجه إلى الستاند أب. جاء اختراقها بعد احتلالها المركز الرابع في "Last Comic Standing" عام 2007، لكنها انفجرت في الوسط الشعبي الواسع عبر برنامجها على Comedy Central الذي حاز Peabody Award.\n\nفيلمها "Trainwreck" الذي كتبته وجسّدت بطولته كان نجاحًا نقديًا وتجاريًا. استخدمت منبرها للمناصرة في مجال ضبط الأسلحة وحقوق المرأة وإيجابية صورة الجسد.`,
    style: 'نسوية، إيجابية جنسيًا، استهزاء بالنفس، تعليق اجتماعي',
    achievements: [
      'Emmy Award',
      'Peabody Award',
      'قائمة Time 100 للشخصيات الأكثر تأثيرًا',
      'مؤلفة كتب من قوائم New York Times للأكثر مبيعًا',
      'ترشيح Grammy',
      'Writers Guild Award',
    ],
  },
];
